import {AlertCircleIcon} from "lucide-react";
import {Component, type ErrorInfo, type ReactNode} from "react";

export class ProvenanceErrorBoundary extends Component<
    {children: ReactNode; onClose: () => void},
    {hasError: boolean; error: string}
> {
    state = {hasError: false, error: ""};

    static getDerivedStateFromError(error: Error) {
        return {hasError: true, error: error.message};
    }

    componentDidCatch(error: Error, info: ErrorInfo) {
        console.error("ProvenancePanel render error:", error, info);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="flex flex-col items-center justify-center py-12 text-center">
                    <AlertCircleIcon className="h-8 w-8 text-red-400 mb-2" />
                    <p className="text-sm font-medium text-red-600">Cell details unavailable</p>
                    <p className="text-xs text-red-400 mt-1 max-w-md">{this.state.error}</p>
                    <button
                        onClick={() => {
                            this.setState({hasError: false, error: ""});
                            this.props.onClose();
                        }}
                        className="mt-3 text-xs text-[#209DB3] hover:underline"
                    >
                        Dismiss
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}
